import { useSelector } from "react-redux"
import { selectPrimaryModalMyTeam, selectSearchValueMyTeam, selectUserId } from "../../features/my-team/my-team-slice"

export const useMyTeamDataState = () => {

    const primaryModal = useSelector(selectPrimaryModalMyTeam);
    const isShowViewProfilePrimaryMyTeam = primaryModal === 'viewProfile'
    const searchValueMyTeam = useSelector(selectSearchValueMyTeam);
    const userIdMyTeam = useSelector(selectUserId);

    return {
        primaryModal,
        isShowViewProfilePrimaryMyTeam,
        searchValueMyTeam,
        userIdMyTeam,
    }
}